module.exports = __webpack_public_path__ + "img/favicon.9f092b52.ico";